import { Icon } from 'shared/ui'
import styles from './styles.module.scss'

type IPhoneRenderContentProps = {
  phone: {
    formatted_number: string
    is_aircall: boolean
  }
}

export const PhoneRenderContent = ({ phone }: IPhoneRenderContentProps) => {
  return (
    <div className={styles.wrap}>
      {phone.formatted_number}
      {phone.is_aircall && <Icon icon={'aircall'} />}
    </div>
  )
}
